import axios from "axios";
import * as apigw from "./apigw"

export interface IPost {
    "type"?: string,
    "id"?: string,
    "user_id"?: string,
    "text"?: string,
    "media"?: string,
    "status"?: string,
    "update_date"?: string,
    "create_date"?: string,
    "next_id"?: string
}

export interface IMedia {
    "total_count": number,
    "item_count": number,
    "item": [{
        "media_id": string,
        "name": string,
        "update_time": string,
        "url": string
    }]
}

export interface ITwitterPost {
    "data"?: ITwitterData[],
    "includes"?: ITwitterIncludes,
    "meta"?: ITwitterMeta
}

export interface ITwitterData {
    "attachments"?: ITwitterAttachment,
    "id"?: string,
    "text"?: string
}

export interface ITwitterAttachment {
    "media_keys"?: string[];
}

export interface ITwitterIncludes {
    "media"?: ITwitterMedia[]
}

export interface ITwitterMedia {
    "media_key"?: string,
    "type"?: string,
    "url"?: string
}

export interface ITwitterMeta {
    "next_token"?: string,
    "result_count"?: string,
    "newest_id"?: string,
    "oldest_id"?: string,
    "previous_token"?: string
}

export interface IInstagramrPost {
    "data"?: IInstagramrData[],
    "paging"?: IInstagramrPaging,
}

export interface IInstagramrData {
    "id"?: string,
    "caption"?: string,
    "media_url"?: string,
}

export interface IInstagramrPaging {
    "cursors"?: {
        "before"?: string,
        "after"?: string
    }
    "next"?: string,
    "previous"?: string
}

export const listPost = async (wechatLastPostId?: string, opts?: any) => {
    const res = await apigw.request<IPost[]>(
        "/system/get-posts",
        { wechatLastPostId },
        opts
    );
    return res;
};

export const getPost = async (id: string, opts?: any) => {
    const res = await apigw.request<any>(
        "/system/get-post",
        { id }
    );
    return res;
};

export const createPost = async (text?: string, media?: string) => {
    const res = await apigw.request<any>(
        "/system/set-post",
        { text, media }
    );
    return res;
};

export const updatePost = async (id: string, text?: string, media?: string) => {
    const res = await apigw.request<any>(
        "/system/update-post",
        { id, text, media }
    );
    return res;
};

export const deletePost = async (id: string) => {
    const res = await apigw.request<any>(
        "/system/del-post",
        { id }
    );
    return res;
};

export const getUploadUrl = async (name: string, type: string) => {
    const res = await apigw.request<any>(
        "/system/get-upload-url",
        { name, type }
    );
    return res;
};

export const putFile = async (url: string, file: any) => {
    return axios({
        method: 'PUT',
        url: url,
        headers: {
            'Content-Type': file.type,
        },
        data: file
    });
};

export const getFile = async (url: string) => {
    return axios({
        method: 'GET',
        url: url,
        responseType: 'arraybuffer'
    });
};

export const addMaterial = async (media: string, accessToken: string) => {
    const res = await apigw.request<any>(
        "/system/add-material",
        { media, accessToken }
    );
    return res;
};

export const addDraft = async (title: string, content: string, thumbMediaId: string, accessToken: string) => {
    const res = await apigw.request<any>(
        "/system/add-draft",
        { title, content, thumbMediaId, accessToken }
    );
    return res;
};

export const wechatPost = async (id: string, mediaId: string, accessToken: string) => {
    const res = await apigw.request<any>(
        "/system/wechat-post",
        { id, mediaId, accessToken }
    );
    return res;
};

export const listTwitterPost = async (nextToken?: string, opts?: any) => {
    const res = await apigw.request<ITwitterPost>(
        "/system/get-twitter-posts",
        { nextToken },
        opts
    );
    return res;
};

export const listInstagramPost = async (nextUrl?: string, opts?: any) => {
    const res = await apigw.request<IInstagramrPost>(
        "/system/get-instagram-posts",
        { nextUrl },
        opts
    );
    return res;
};

export const textTranslation = async (text: string, opts?: any) => {
    const res = await apigw.request<any>(
        "/system/text-translation",
        { text },
        opts
    );
    return res;
};
